/**
 * A2 No86_2: 一部助成 label suffix derived from special_calculation_cost (calc_type +
 * limit_*). Shared by MedicalAidSection (current selection display) and
 * MedicalAidSearchModal (補助入力 dropdown row label).
 */
export function formatSpecialCalculation(
  calcType: number | null | undefined,
  limitAmount: number | null | undefined,
  limitNumMonth: number | null | undefined,
  limitAmountMonth: number | null | undefined
): string {
  if (calcType == null) return '';
  const nf = (v: number | null | undefined) => (v ?? 0).toLocaleString('en-US');
  if (calcType === 1) return `1回${nf(limitAmount)}円　月${limitNumMonth ?? 0}回まで`;
  if (calcType === 2) return `1ヵ月上限（限度額）${nf(limitAmountMonth)}円`;
  if (calcType === 3) {
    return `1回${nf(limitAmount)}円　までで 1ヵ月上限（限度額）${nf(limitAmountMonth)}円`;
  }
  return '';
}

/** 請求区分 code meaning 請求不可 (insurers.medix_claim_type_id). */
export const MEDICAL_AID_CLAIM_TYPE_NO_CLAIM = 1;

/**
 * HIT-14777 (UAT Sprint5 No.206): a 公費負担者 must not be applied when its 請求区分 is 請求不可
 * or it is disabled for invoicing. Shared by every way of picking a 公費負担者番号
 * (補助入力 modal, interval table, direct number search).
 */
export function isMedicalAidNoClaim(insurer: {
  claim_type_id?: number | string | null;
  medix_claim_type_id?: number | string | null;
  is_enabled_invoice?: boolean | null;
}): boolean {
  const raw = insurer.claim_type_id ?? insurer.medix_claim_type_id;
  if (raw !== null && raw !== undefined && Number(raw) === MEDICAL_AID_CLAIM_TYPE_NO_CLAIM) {
    return true;
  }
  return insurer.is_enabled_invoice === false;
}
